import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import { useAuth } from './store';

interface MeResponse {
  data: {
    user: {
      id: number;
      name: string;
      email: string;
      locale: string;
      timezone: string;
      avatar_path?: string | null;
    };
    permissions: string[];
    roles: string[];
    tenant: {
      id: string | null;
      enabled: string[];
    };
  };
}

export function useMe() {
  const setSession = useAuth((s) => s.setSession);
  const currentTenantId = useAuth((s) => s.currentTenantId);
  const tenants = useAuth((s) => s.tenants);

  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const { data } = await api.get<MeResponse>('/api/v1/me');
      setSession({
        user: data.data.user,
        tenants: tenants,
        currentTenantId: data.data.tenant.id ?? currentTenantId,
        permissions: data.data.permissions,
        roles: data.data.roles,
        enabledModules: data.data.tenant.enabled,
      });
      return data.data;
    },
    retry: false,
  });
}
